/**
 * Outbox adapter — queue transactional email through the store.
 *
 * In Firestore mode a write here lands in the `outbox` collection that the
 * deployed `processOutboxEmail` Cloud Function watches and sends via Brevo
 * (it flips `status` queued → sent | error). In local/mock mode it queues
 * honestly but nothing sends — the doc is the record; we never show a false
 * "sent". Going live is config (VITE_USE_FIRESTORE + the Function), not code.
 */

import { db, nowIso, uuid } from './store';
import type { OutboxDoc } from './types';

export interface QueueEmailInput {
  to: string;
  subject: string;
  textContent?: string;
  htmlContent?: string;
}

export async function queueEmail(input: QueueEmailInput): Promise<OutboxDoc> {
  const ts = nowIso();
  const rec: OutboxDoc = {
    id: uuid(),
    to: input.to,
    subject: input.subject,
    textContent: input.textContent,
    htmlContent: input.htmlContent,
    status: 'queued',
    createdAt: ts,
    updatedAt: ts,
  };
  await db.add('outbox', rec);
  return rec;
}

export async function listOutbox(): Promise<OutboxDoc[]> {
  return db.list('outbox');
}

export function subscribeOutbox(fn: (docs: OutboxDoc[]) => void): () => void {
  return db.subscribe('outbox', fn);
}
